module.exports = __webpack_public_path__ + "img/word.1165711.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/word.png
// module id = GJ+t
// module chunks = 2 3 6 8 15 49